module.exports = __webpack_public_path__ + "static/media/reply.ad45a307.svg";